import React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";

export default function ErrorMessage({
  message = "Something went wrong. Please try again.",
  onRetry,
  testId = "error-message",
}) {
  return (
    <div
      data-testid={testId}
      className="flex items-start gap-3 rounded-lg border border-red-100 bg-red-50/70 p-4 text-[12.5px] text-red-700"
    >
      <AlertCircle size={16} className="mt-0.5 shrink-0" />
      <div className="flex-1">
        <div className="font-medium">{message}</div>
        {onRetry && (
          <button
            data-testid={`${testId}-retry`}
            onClick={onRetry}
            className="mt-2 inline-flex items-center gap-1 rounded-md bg-white px-2 py-1 text-[11.5px] font-medium text-red-700 ring-1 ring-red-200 hover:bg-red-50"
          >
            <RefreshCw size={12} />
            Try again
          </button>
        )}
      </div>
    </div>
  );
}
